import React from 'react';
import { graphql } from 'gatsby';

import { HEADER_BLOCK_TYPENAMES } from '../constants';
import { getFirst, redirectIfEdit } from '../utilities/misc';

import FlexibleBlock from '../components/FlexibleBlock';
import Layout from '../components/Layout';
import PageHead from '../components/PageHead';

const Page = ({ data, pageContext }) => {
  const landingPage = data.contentfulLandingPage;
  const { layout, blocks } = landingPage;
  const page = getFirst(landingPage.page);
  const hasLayoutHeader = layout?.blocksBeforeContent?.some(
    (block) => HEADER_BLOCK_TYPENAMES.includes(block.__typename)
  ) ?? false;
  const firstHeaderBlockIndex = !hasLayoutHeader ? blocks?.findIndex(
    (block) => HEADER_BLOCK_TYPENAMES.includes(block.__typename)
  ) : null;

  redirectIfEdit(page.contentfulId, true);

  return (
    <Layout
      language={pageContext.language}
      pageOverrides={page.pageOverrides}
      freeTrialOverride={page.freeTrialOverride}
      navigationType={layout?.navigationType}
      blocksBeforeContent={layout?.blocksBeforeContent}
      blocksAfterContent={layout?.blocksAfterContent}
    >
      {blocks && blocks.map((block, index) => (
        <FlexibleBlock
          // Can't assume block id is unique, so need to use index
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          type={block.__typename}
          data={block}
          // This only applies to header blocks that use H1's
          useH1={index === firstHeaderBlockIndex}
        />
      ))}
    </Layout>
  );
};

export const Head = ({ data, pageContext }) => {
  const landingPage = data.contentfulLandingPage;
  const page = getFirst(landingPage.page);

  return (
    <PageHead
      language={pageContext.language}
      title={page.title}
      seo={page.seo}
      updatedAt={landingPage.updatedAt}
    />
  );
};

export const query = graphql`
  query SingleLandingPage($id: String!, $language: String!) {
    contentfulLandingPage(id: { eq: $id }, node_locale: { eq: $language }) {
      updatedAt
      page {
        contentfulId: contentful_id
        title
        pageOverrides
        freeTrialOverride
        seo {
          ...SeoFragment
        }
      }
      layout {
        ...LayoutFragment
      }
      blocks {
        ...FlexibleBlockFragment
      }
    }
  }
`;

export default Page;
